import { Artist, ArtistRegisterStatus } from '@favid-inc/api';
import { WhereElement } from '@favid-inc/api/lib/rest';
import { Filter } from 'core/generic';
import { Action, stateReducerFactory } from 'core/generic';
import { Paginate } from 'core/paginate';
import { SubAccount } from 'features/iugo';
import _ from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { EmptyList, Loading } from 'utils/GenericCompoents';
import { ConfirmDenyRegister, fetchArtists } from './';
import defaultUserImage from './default-user-image.png';
import {
  BEFORE_PROCESSING,
  ON_FETCH_ARTISTS,
  ON_UPDATE_ARTIST,
  ROLLBACK_INITIAL_STATE,
} from './types';

interface State {
  list: Artist[];
  total: number;
  isLoading: boolean;
  filter: Filter;
  searchValue: string;
  searchBy: string;
  iugo: {
    artist?: Artist;
    isModalApproveOpen: boolean;
    isModalDennyOpen: boolean;
  };
}

const initialState: State = {
  list: [],
  total: 0,
  isLoading: false,
  searchValue: '',
  searchBy: 'name',
  filter: {
    page: 0,
    itensPerPage: 20,
    where: [
      {
        attr: 'registerStatus',
        exp: '=',
        value: ArtistRegisterStatus.APPROVED,
      },
    ],
  },
  iugo: {
    isModalApproveOpen: false,
    isModalDennyOpen: false,
  },
};

const reducer = stateReducerFactory({
  onPut: ON_UPDATE_ARTIST,
  onFetch: ON_FETCH_ARTISTS,
  beforeProcessing: BEFORE_PROCESSING,
  onError: ROLLBACK_INITIAL_STATE,
  initialState,
});

class ListArtistComponent extends React.Component<{}, State> {
  state: State = initialState;

  private search = _.debounce(() => {
    const { filter } = this.state;
    if (this.state.searchValue === '') {
      filter.where = [
        {
          attr: 'registerStatus',
          exp: '=',
          value: ArtistRegisterStatus.APPROVED,
        },
      ];
    } else {
      filter.where = [
        {
          exp: 'LIKE',
          attr: this.state.searchBy,
          value: this.state.searchValue,
        },
      ];
    }

    return fetchArtists(filter, this.dispach);
  }, 500);

  componentDidMount() {
    fetchArtists(this.state.filter, this.dispach);
  }

  dispach = (action: Action) => {
    this.setState(() => reducer(this.state, action));
  };

  onPaginateChange = async (selectedItem: { selected: number }) => {
    const filter: Filter = {
      page: selectedItem.selected,
      itensPerPage: this.state.filter.itensPerPage,
    };

    await this.setState({ filter });
    fetchArtists(this.state.filter, this.dispach);
  };

  onChangeFilter = async (event: React.SyntheticEvent<HTMLButtonElement>) => {
    const value = event.currentTarget.dataset.value;
    let where: WhereElement[] | undefined;
    if (value) {
      where = [
        {
          attr: 'registerStatus',
          exp: '=',
          value,
        },
      ];
    }
    const { filter } = this.state;
    await this.setState({
      filter: { ...filter, where },
    });
    fetchArtists(this.state.filter, this.dispach);
  };

  onCloseModalIugo = () => {
    const iugo = {
      artist: undefined,
      isModalApproveOpen: false,
      isModalDennyOpen: false,
    };
    this.setState({ iugo });
  };

  onDenyRegister = (event: React.MouseEvent<HTMLElement>) => {
    const index = Number(event.currentTarget.dataset.value);
    const artist = this.state.list[index];
    const iugo = { artist, isModalApproveOpen: false, isModalDennyOpen: true };
    this.setState({ iugo });
  };

  onApproveRegister = async (event: React.MouseEvent<HTMLElement>) => {
    const index = Number(event.currentTarget.dataset.value);
    const artist = this.state.list[index];
    const iugo = { artist, isModalApproveOpen: true, isModalDennyOpen: false };
    this.setState({ iugo });
  };

  getFilter() {
    const {
      filter: { page, itensPerPage },
    } = this.state;

    return {
      page,
      itensPerPage,
    };
  }

  onSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchValue: event.target.value });
    this.search();
  };

  onChangeSearchType = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ searchBy: event.target.value });
    this.search();
  };

  renderSegment() {
    const { where } = this.state.filter;
    const { APPROVED, DENIED, PENDING } = ArtistRegisterStatus;
    const selectedSegment = where ? where[0].value : '';

    const all = !where ? 'active' : '';
    const negados =
      selectedSegment === ArtistRegisterStatus.DENIED ? 'active' : '';
    const pendentes =
      selectedSegment === ArtistRegisterStatus.PENDING ? 'active' : '';
    const aprovados =
      selectedSegment === ArtistRegisterStatus.APPROVED ? 'active' : '';

    return (
      <div className='ui top attached tabular menu'>
        <button
          className={`item ${aprovados}`}
          data-value={APPROVED}
          onClick={this.onChangeFilter}
        >
          Aprovados
        </button>
        <button
          className={`item ${pendentes}`}
          data-value={PENDING}
          onClick={this.onChangeFilter}
        >
          Pendentes
        </button>
        <button
          className={`item ${negados}`}
          data-value={DENIED}
          onClick={this.onChangeFilter}
        >
          Negados
        </button>
        <button className={`item ${all}`} onClick={this.onChangeFilter}>
          Todos
        </button>
      </div>
    );
  }

  renderApproveButtons(index: number, registerStatus?: ArtistRegisterStatus) {
    if (registerStatus !== ArtistRegisterStatus.PENDING) {
      return null;
    }

    return (
      <div className='content right floated'>
        <div className='ui mini buttons'>
          <button
            className='ui negative button'
            data-value={index}
            onClick={this.onDenyRegister}
          >
            Negar
          </button>
          <div className='or' data-text='ou' />
          <button
            className='ui positive button'
            data-value={index}
            onClick={this.onApproveRegister}
          >
            Aprovar
          </button>
        </div>
      </div>
    );
  }

  renderArtists() {
    const { isLoading, list } = this.state;

    if (isLoading) {
      return <Loading />;
    }

    if (list.length === 0) {
      return <EmptyList message='Não existem artistas para serem exibidos' />;
    }

    const artistsContent = list.map((artist, index) => (
      <div key={artist.id} className='item'>
        <ArtistItem>
          <div>
            <Link to={`/artists/${artist.id}`}>
              <div className='avatar' style={{ backgroundImage: `url(${artist.photoUri || defaultUserImage})` }} />
              <p>Detalhes</p>
            </Link>
          </div>
          <div>
            <dl>
              <dt>Nome</dt>
              <dd>{artist.name}</dd>
              <dt>Nome artistico</dt>
              <dd>{artist.artisticName}</dd>
              <dt>Email</dt>
              <dd>{artist.email}</dd>
              <dt>Bio</dt>
              <dd>{artist.biography}</dd>
            </dl>
          </div>
          <div>{this.renderApproveButtons(index, artist.registerStatus)}</div>
        </ArtistItem>
      </div>
    ));

    const {
      filter: { page, itensPerPage },
    } = this.state;

    return (
      <div>
        <div className='ui header'>
          <h3 style={{ textAlign: 'left' }}>Lista de artistas</h3>
        </div>
        <div className='ui middle aligned divided list'>
          {artistsContent}
          <Paginate
            page={page}
            itensPerPage={itensPerPage}
            onPaginateChange={this.onPaginateChange}
            total={this.state.total}
          />
        </div>
      </div>
    );
  }

  render() {
    const { iugo } = this.state;

    if (iugo.isModalApproveOpen && iugo.artist) {
      return (
        <SubAccount
          artist={iugo.artist}
          onUpdateArtist={this.dispach}
          onClose={this.onCloseModalIugo}
        />
      );
    }

    if (iugo.isModalDennyOpen && iugo.artist) {
      return (
        <ConfirmDenyRegister
          artist={iugo.artist}
          onUpdateArtist={this.dispach}
          onClose={this.onCloseModalIugo}
        />
      );
    }

    return (
      <div>
        <form className='ui form'>
          <div className='two fields'>
            <div className='field'>
              <label>Busca</label>
              <input value={this.state.searchValue} onChange={this.onSearch} />
            </div>
            <div className='field'>
              <label>Buscar Por</label>
              <select
                className='ui fluid dropdown'
                onChange={this.onChangeSearchType}
              >
                <option value='artisticName'>Nome</option>
                <option value='email'>E-mail</option>
              </select>
            </div>
          </div>
        </form>
        {this.renderSegment()}
        <div className='ui bottom attached tab segment active'>
          {this.renderArtists()}
        </div>
      </div>
    );
  }
}

export const ListArtist = ListArtistComponent;

const ArtistItem = styled.div`
  display: grid;
  grid-template-columns: 72px 1fr;

  > :nth-child(2) {
    margin: 0 3em;
    flex-grow: 2;
  }

  a p {
    text-align: center;
  }

  .avatar {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border: 1px solid #e9e9e9;
    display: block;
    height: 64px;
    margin: auto;
    width: 64px;
  }

  dl {
    display: grid;
    grid-template-columns: 100px 1fr;
  }

  dt {
    text-align: right;
    font-weight: bold;
    &::after {
      content: ":";
    }
  }
  dd {
    margin-inline-start: 10px;
  }
`;
